import React, { createContext, useContext, useState } from 'react';

export interface Theme {
  colorPrimary: string;
  colorSecondary: string;
  font: string;
  inputHeight: number;
  borderRadius: number;
  colorPrimaryHalfOpacity: string;
  colorPrimaryQuarterOpacity: string;
}

const defaultTheme: Theme = {
  colorPrimary: "#322b5d",
  colorSecondary : "#f47920",
  font: 'Montserrat',
  inputHeight: 36,
  borderRadius: 8,
  get colorPrimaryHalfOpacity() {
    return this.colorPrimary + "4c"
  },
  get colorPrimaryQuarterOpacity() {
    return this.colorPrimary + "1c"
  }
};

interface ThemeContextType {
  theme: Theme;
  updateTheme: (newTheme: Partial<Theme>) => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [theme, setTheme] = useState<Theme>(defaultTheme);

  const updateTheme = (newTheme: Partial<Theme>) => {
    setTheme(prevTheme => ({
      ...prevTheme,
      ...newTheme,
    }));

    if (newTheme.colorPrimary) {
      document.documentElement.style.setProperty("--antd-primary-color", newTheme.colorPrimary);
      document.documentElement.style.setProperty("--antd-icon-color", newTheme.colorPrimary);
    }

    if (newTheme.colorSecondary) {
      document.documentElement.style.setProperty("--antd-secondary-color", newTheme.colorSecondary);
    }

    if (newTheme.font) {
      document.documentElement.style.setProperty("--antd-font-family", newTheme.font);
    }

  };

  return (
    <ThemeContext.Provider value={{ theme, updateTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}; 